import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Typography } from "@mui/joy";
import { useState } from "react";

import { LandingSection } from "../../../LandingLayout";
import { FadeIn } from "~/common/components";

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "Для чого потрібен Brandly?",
    answer:
      "Brandly автоматизує рутинний моніторинг реєстру УКРНОІВІ. Ви додаєте номер заявки, а система бере на себе щоденні перевірки статусів та контроль дедлайнів. Це економить понад 80% часу, який зазвичай витрачається на ручне супроводження торговельних марок, і гарантує, що жодна заявка не загубиться.",
  },
  {
    question: "Як приходять нагадування про дедлайни?",
    answer:
      "Миттєво у ваш Telegram. Ви підключаєте нашого бота до свого акаунту або робочої групи, і він надсилає сповіщення про зміну статусів, нові запити від експертизи та наближення критичних строків.",
  },
  {
    question: "За скільки днів до дедлайну будуть нагадування?",
    answer:
      "Система надсилає каскадні сповіщення за 62, 31, 14, 5 та 2 дні до дедлайну. Ви отримуєте достатньо часу на підготовку відповіді без ризику пропустити строк.",
  },
  {
    question: "Чи безпечні мої дані?",
    answer:
      "Абсолютно. Brandly працює в режимі «лише читання» з офіційними даними реєстру УКРНОІВІ. Ми не маємо доступу до ваших внутрішніх документів чи комерційної таємниці, а всі облікові записи захищені сучасними стандартами шифрування.",
  },
  // {
  //   question: "Чи працює система з іноземними заявками?",
  //   answer: "Поки що Brandly контролює тільки заявки, подані до УКРНОІВІ.",
  // },
  // {
  //   question: "Чи можу я надати доступ юристу або партнеру?",
  //   answer:
  //     "Так. Brandly створений для командної роботи. Ви можете запросити колег у свій робочий простір, щоб разом керувати спільним портфелем заявок без дублювання завдань.",
  // },
  // {
  //   question: "Скільки коштує користування системою?",
  //   answer:
  //     "Це щомісячна підписка. Ціна залежить від того, скільки заявок ви відстежуєте. Деталі — у розділі «Тарифи».",
  // },
  // {
  //   question: "Як швидко оновлюється статус заявки?",
  //   answer:
  //     "Щодня. Наші сервери автоматично синхронізуються з базою УКРНОІВІ кожні 24 години, тому ви завжди бачите актуальний стан справ без ручних перевірок реєстру.",
  // },
  {
    question: "Чи потрібен електронний підпис?",
    answer:
      "Ні. Для моніторингу заявок у Brandly КЕП не потрібен. Електронний підпис знадобиться вам лише для безпосередньої подачі документів до УКРНОІВІ через їхню офіційну систему.",
  },
  {
    question: "Чи підходить Brandly для ведення заявок різних клієнтів?",
    answer:
      "Так, це наш основний фокус. Платформа створена спеціально для юристів та фірм, які ведуть десятки або сотні заявок. Усі клієнтські справи зібрані в єдиному дашборді зі зручним пошуком та фільтрацією.",
  },
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <LandingSection bgcolor="background.level1" id="faq">
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 4, md: 8 },
        }}
      >
        {/* Left side - Title */}
        <Box
          sx={{
            flex: { xs: "1", md: "0 0 35%" },
            maxWidth: { md: "35%" },
          }}
        >
          <FadeIn offsetY={20} duration={300} delay={100}>
            <Typography
              level="h2"
              sx={{
                fontSize: { xs: "1.75rem", md: "2rem", lg: "2.25rem" },
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              Ще є питання?
            </Typography>
          </FadeIn>
        </Box>

        {/* Right side - Accordion */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {faqItems.map((item, index) => (
            <FadeIn
              key={index}
              offsetY={20}
              duration={300}
              delay={150 + index * 50}
            >
              <Box
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "neutral.200",
                }}
              >
                <Box
                  component="button"
                  onClick={() => handleToggle(index)}
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 2.5,
                    px: 0,
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                    willChange: "height",
                    // transition: " 0.25s",
                    "&:hover": {
                      "& .faq-question": {
                        color: "primary.600",
                      },
                    },
                  }}
                >
                  <Typography
                    className="faq-question"
                    sx={{
                      fontSize: { xs: "0.938rem", md: "1rem" },
                      fontWeight: 500,
                      pr: 2,
                      transition: "color 0.25s",
                    }}
                  >
                    {item.question}
                  </Typography>
                  <Box
                    sx={{
                      flexShrink: 0,
                      color: "neutral.600",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {openIndex === index ? (
                      <RemoveIcon sx={{ fontSize: 20 }} />
                    ) : (
                      <AddIcon sx={{ fontSize: 20 }} />
                    )}
                  </Box>
                </Box>

                {/* Answer */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateRows: openIndex === index ? "1fr" : "0fr",
                    transition: "grid-template-rows 0.3s ease-in-out",
                  }}
                >
                  <Box sx={{ overflow: "hidden" }}>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.875rem", md: "0.938rem" },
                        // color: "neutral.700",
                        lineHeight: 1.6,
                        pb: 2.5,
                        pr: { xs: 4, md: 8 },
                      }}
                    >
                      {item.answer}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </FadeIn>
          ))}
        </Box>
      </Box>
    </LandingSection>
  );
};
